import { render } from "./ExportToExcelForTabs.vue?vue&type=template&id=3a3d9fca&scoped=true&ts=true"
import script from "./ExportToExcelForTabs.vue?vue&type=script&lang=ts"
export * from "./ExportToExcelForTabs.vue?vue&type=script&lang=ts"

import "./ExportToExcelForTabs.vue?vue&type=style&index=0&id=3a3d9fca&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a3d9fca"]])

export default __exports__